import Tiles from '../Tiles';

function Home() {
  return <Tiles />;
}

export default Home;
